var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSurveyFullManual(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 109,
    viewBox: "0 0 117 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.18 0h96.66v109H.18V0z",
    fill: "#5959EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.377 7.198h82.264v94.604H7.377V7.198z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.956 17.371c.629.575.672 1.55.098 2.18l-7.53 8.234-4.822-3.646a1.543 1.543 0 0 1 1.86-2.461l2.582 1.952 5.633-6.161a1.543 1.543 0 0 1 2.179-.098zM27.956 36.909c.629.575.672 1.55.098 2.179l-7.53 8.235-4.822-3.647a1.543 1.543 0 1 1 1.86-2.46l2.582 1.952 5.633-6.162a1.543 1.543 0 0 1 2.179-.097zM27.956 75.47c.629.575.672 1.55.098 2.18l-7.53 8.234-4.822-3.646a1.543 1.543 0 0 1 1.86-2.461l2.582 1.952 5.633-6.161a1.543 1.543 0 0 1 2.179-.098z",
    fill: "#19D89F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.598 56.494a1.542 1.542 0 0 0 0 2.182l7.198 7.198a1.542 1.542 0 1 0 2.181-2.182l-7.198-7.198a1.542 1.542 0 0 0-2.181 0z",
    fill: "#BF3DC2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.977 56.494a1.542 1.542 0 0 1 0 2.182l-7.198 7.198a1.542 1.542 0 1 1-2.181-2.182l7.198-7.198a1.542 1.542 0 0 1 2.181 0z",
    fill: "#BF3DC2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.656 21.594a4.627 4.627 0 0 1 4.627-4.627H78.33a4.627 4.627 0 1 1 0 9.255H40.283a4.627 4.627 0 0 1-4.627-4.628zM35.656 41.132a4.627 4.627 0 0 1 4.627-4.627H78.33a4.627 4.627 0 1 1 0 9.255H40.283a4.627 4.627 0 0 1-4.627-4.628zM35.656 79.693a4.627 4.627 0 0 1 4.627-4.627H78.33a4.627 4.627 0 1 1 0 9.255H40.283a4.627 4.627 0 0 1-4.627-4.628zM35.656 60.67a4.627 4.627 0 0 1 4.627-4.628H78.33a4.627 4.627 0 1 1 0 9.255H40.283a4.627 4.627 0 0 1-4.627-4.627z",
    fill: "#000"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.377 94.604h82.264v7.198H7.377v-7.198zM102.857 28.392l10.196 5.65-25.9 46.734-10.197-5.651 25.901-46.733z",
    fill: "#F8D856"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M104.741 24.993a3.885 3.885 0 0 1 5.282-1.515l3.399 1.884a3.886 3.886 0 0 1 1.515 5.282l-1.884 3.399-10.196-5.651 1.884-3.399z",
    fill: "#BF3DC2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M78.287 84.748c-1.02-.565-1.312-6.651-1.33-9.623l10.195 5.65c-2.53 1.56-7.846 4.538-8.865 3.973z",
    fill: "#F8D856"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyFullManual);
export default __webpack_public_path__ + "static/media/survey-full-manual.ad02ed492538844b6a62a8a01cd97a3a.svg";
export { ForwardRef as ReactComponent };